// extracted by mini-css-extract-plugin
module.exports = {"text":"_ffceaa","screenshotImage":"_0f8fef","card":"_c81609","freeTrialTag":"_bc2db9"};